import React, { useState } from 'react';

import { ErrorMessage, Field, FieldProps } from 'formik';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import './DateRange.css';
import { i18n } from 'utils/i18n';
import DatePicker, {
  DayRange,
  Locale,
} from '@amir04lm26/react-modern-calendar-date-picker';
// no working on react v17 import DatePicker, {
//   DayRange,
//   Locale,
// } from 'react-modern-calendar-datepicker';

export type DateRangeDates = {
  from: Date | null;
  to: Date | null;
};

const customLocale = {
  // months list by order
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],

  // week days by order
  weekDays: [
    {
      name: 'Domingo', // used for accessibility
      short: 'D', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: 'Segunda',
      short: 'S',
    },
    {
      name: 'Terça',
      short: 'T',
    },
    {
      name: 'Quarta',
      short: 'Q',
    },
    {
      name: 'Quinta',
      short: 'Q',
    },
    {
      name: 'Sexta',
      short: 'S',
    },
    {
      name: 'Sábado',
      short: 'S',
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Select...',

  // for input range value
  from: 'from',
  to: 'to',

  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
} as Locale;

interface DateRangeProps {
  name: string;
  className?: string;
  initialValues?: DayRange;
  onChangeCallback? :() => void
  isDisabled?: boolean
  calendarPopperPosition?: 'bottom';
}
const DateRange: React.FC<DateRangeProps> = (props) => {
  return <Field component={DateRangeChild} {...props} />;
};

interface DateRangeChildProps extends FieldProps, DateRangeProps {}

const DateRangeChild: React.FC<DateRangeChildProps> = ({
  className,
  field,
  form,
  initialValues = { from: null, to: null },
  meta,
  onChangeCallback
}) => {
  const handleOnChange = (dateRange: DayRange) => {
    const { from, to } = dateRange;

    const processedFrom = from
      ? new Date(from.year, from.month - 1, from.day)
      : null;
    const processedTo = to
      ? new Date(to.year, to.month - 1, to.day, 23, 59, 59)
      : null;

    const result = {
      from: processedFrom,
      to: processedTo,
    };

    form.setFieldValue(field.name, result);
    if (onChangeCallback && from && to){
      onChangeCallback()
    }
  };

  const handleValue = (
    dateRange: { from: null | Date; to: null | Date } | undefined
  ) => {
    if (!dateRange) return initialValues;

    const { from, to } = dateRange;
    const processedFrom = from
      ? {
          year: from.getFullYear(),
          month: from.getMonth() + 1,
          day: from.getDate(),
        }
      : null;
    const processedTo = to
      ? {
          year: to.getFullYear(),
          month: to.getMonth() + 1,
          day: to.getDate(),
        }
      : null;
    const convertedDateRange = {
      from: processedFrom,
      to: processedTo,
    };
    return convertedDateRange;
  };

  const resetValues = () => {
    const result = {
      from: null,
      to: null,
    };
    form.setFieldValue(field.name, result);
  };
  return (
    <div className={`${className} relative`}>
      <DatePicker
        inputClassName="text-sm py-2 rounded-input text-left w-56"
        inputPlaceholder= {i18n.t("datePicker")}
        colorPrimary="#3200D9"
        colorPrimaryLight="#DFE2FD" // change to meritu colors
        calendarClassName="responsive-calendar"
        shouldHighlightWeekends
        value={handleValue(field.value)}
        onChange={handleOnChange}
        locale={customLocale}
        renderFooter={() => DateRangeFooter({ resetValues })}
        calendarPopperPosition='bottom'
      />
      <p className="text-xs text-red absolute font-bold">
        <ErrorMessage name={field.name} />
      </p>
    </div>
  );
};

const DateRangeFooter: React.FC<{ resetValues: () => void }> = ({
  resetValues,
}) => (
  <div className="w-full pb-2 px-4 flex justify-end">
    <button
      className="text-sm px-3 py-2 bg-primary rounded-input text-white cursor"
      onClick={resetValues}
    >
      Limpar
    </button>
  </div>
);

export default DateRange;
